import saveGeneralSettings, { SaveGeneralSettingsPayload } from './saveGeneralSettings';
import saveMailingSettings, { SaveMailingSettingsPayload } from './saveMailingSettings';
import saveEmailNotificationSettings from './saveEmailNotificationSettings';
import {EmailNotificationSettingsFormData} from './fetchEmailNotificationSettings';

export type SaveSettingsPayload = SaveGeneralSettingsPayload | SaveMailingSettingsPayload | EmailNotificationSettingsFormData;

const saveSettings = async (name: string, payload: SaveSettingsPayload): Promise<unknown> => {
    switch (name) {
        case 'SettingsGeneral':
            return await saveGeneralSettings(payload as SaveGeneralSettingsPayload);
        case 'SettingsEmailTemplates':
            return await saveMailingSettings(payload as SaveMailingSettingsPayload);
        case 'SettingsEmailNotifications':
            return await saveEmailNotificationSettings(payload as EmailNotificationSettingsFormData);
        default:
            break;
    }
}

export default saveSettings;
